type Props = {
  src?: string
  alt?: string
}

const baseSize = 'w-44 h-44 sm:w-52 sm:h-52'

export const Avatar = ({ src, alt = '' }: Props) => {
  if (src) {
    return (
      <div
        className={`${baseSize} shrink-0 rounded-2xl bg-ink-50 p-1.5 ring-1 ring-ink-400/40 shadow-sm`}
      >
        <img
          src={src}
          alt={alt}
          width={640}
          height={640}
          loading="eager"
          decoding="async"
          className="w-full h-full rounded-xl object-cover"
        />
      </div>
    )
  }

  return (
    <div
      aria-hidden="true"
      className={`${baseSize} shrink-0 rounded-2xl bg-ink-100 ring-1 ring-ink-400/40 shadow-sm flex items-center justify-center text-ink-400 text-sm font-mono tracking-widest select-none`}
    >
      PHOTO
    </div>
  )
}
